module.exports = __webpack_public_path__ + "static/media/Mazda.2759f9f9.png";